import { gql } from '@apollo/client';

export const GET_VENDORS_KPIS = gql`
  query GetVendorsKPIs($vendorNames: [String!]!) {
    getVendorsKPIs(vendorNames: $vendorNames) {
      vendorName
      MDSDays
      stockRotationDays
      priceVsMarketPercentage
      listingsAmount
      uniqueVehiclesAmount
    }
  }
`;
